import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const INDEXABLE = new Set(["/", "/guide", "/privacy", "/terms", "/refund-policy", "/shipping-policy", "/contact"]);

/** Only marketing and policy pages may be indexed; QR, profile, order and admin pages hold personal data. */
const RobotsMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let tag = document.querySelector('meta[name="robots"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "robots");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", INDEXABLE.has(pathname) ? "index,follow" : "noindex,nofollow");
  }, [pathname]);

  return null;
};

export default RobotsMeta;
